module.exports = __webpack_public_path__ + "media/images/forms-icons/file-upload-icon-hover-5d4e8a4c80d4b2153456783d27f1495a.svg";